export const API_URL = 'https://ecommerce-graphql-api-101.glitch.me/';
// export const API_URL = 'http://localhost:4000/';
